import { PersonaModel } from "../types/persona";

export function convertObjectKeyToLabel(text: string): string {
    return text
        .split("_") // Split the text into words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
        .join(" "); // Join the words back together with spaces
}

export function formatFileSize(bytes: number) {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) {
        return "0 Bytes";
    }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
    return `${parseFloat((bytes / 1024 ** i).toFixed(2))} ${sizes[i]}`;
}

export function getFileNameAndExtension(file: File | string) {
    // Get the file name and split it to get the file extension
    if (typeof file === "string") {
        const fileName = file.split(".");
        return { extension: fileName.pop()?.toLowerCase(), name: fileName[0] };
    } else {
        const fileName = file.name.split(".");
        return { extension: fileName.pop()?.toLowerCase(), name: fileName[0] };
    }
}

export function truncateText(text: string, length = 200) {
    if (text.length < length) {
        return text;
    }
    return text.slice(0, length) + "..";
}

export function capitalizeWord(word: string) {
    if (!word) {
        return "";
    }
    return word.charAt(0).toUpperCase() + word.slice(1);
}

export function getPersonaFullName(persona: PersonaModel, personaString?: string): string {
    if (persona && persona.first_name) {
        return `${persona.first_name} ${persona.last_name}`;
    } else {
        return personaString || "";
    }
}

export function getPersonaProfilePicture(persona: PersonaModel): string {
    if (persona && persona.profile_picture) {
        return persona.profile_picture;
    } else {
        return "";
    }
}

export function formatSnakeCaseToTitleCase(text: string): string {
    if (!text) {
        return "";
    }
    return text
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}
